import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    width: 100%;
`;

export const Container = styled.div`
    max-width: 600px;
    /* margin: 0 auto; */
    padding: 20px;
    /* border: 1px solid #ddd; */
    border-radius: 8px;
    background-color: #fff;
`;

export const Section = styled.div`
    margin-bottom: 20px;
`;

export const Title = styled.h2`
    font-size: 1rem;
    margin-bottom: 16px;
`;

export const Details = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;

    &:last-child {
        border-bottom: none;
    }
`;
export const LabelContainer = styled.div`
    width: 45%;
    padding: 12px 0;
    border-right: 2px solid rgb(170 166 166);
`;
export const Label = styled.span`
    font-size: 16px;
    color: #000000;
`;
export const ValueContainer = styled.div`
    width: 60%;
    max-width: 300px;
    margin-left: 16px;
    text-align: left;
    padding: 12px 0;
    word-break: break-word;
`;
export const Value = styled.span`
    font-size: 16px;
    color: #000000;
`;

export const Link = styled.a`
    color: #007bff;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
`;

export const Button = styled.button`
    background-color: #5e5ce6;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 12px 20px;
    margin: 20px 0;
    font-size: 1rem;
    cursor: pointer;

    &:hover {
        background-color: #4d4bd1;
    }
`;

export const EmiConfirmationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 8px 0;
`;

export const EmiWarningIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background-color: #fef9e7;
    border-radius: 50%;
    margin-bottom: 16px;
`;

export const EmiConfirmationTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #040222;
    margin: 0 0 12px 0;
`;

export const EmiConfirmationText = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #5b5675;
    line-height: 22px;
    margin: 0 0 24px 0;
    padding: 0 8px;
`;

export const EmiConfirmationButtons = styled.div`
    display: flex;
    gap: 12px;
    width: 100%;
`;

export const EmiCancelButton = styled.button`
    flex: 1;
    padding: 12px 24px;
    border: 1px solid #e7e7f0;
    border-radius: 8px;
    background: #ffffff;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #f5f5f5;
    }
`;

export const EmiConfirmButton = styled.button`
    flex: 1;
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    background: #00a676;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #008f64;
    }
`;
